<template>
  <div class="menu-switch flex items-center justify-between bg-fillColor-2 p-2 flex-wrap" :style="style">
    <div class="label flex items-center">
      <div class="label__circle mr-2" />
      <span>{{ label }}</span>
    </div>
    <el-switch v-if="!disabled" v-model="val" :active-color="activeColor" :inactive-color="inactiveColor" @change="onChange" />
    <slot />
  </div>
</template>

<script>
import { Switch } from 'element-ui'
import {insertStep} from "~/utils/event";

export default {
  name: "MenuSwitch",
  components: {
    ElSwitch: Switch,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: '开关'
    },
    targetKey: {
      type: String,
      default: ''
    },
    activeColor: {
      type: String,
      default: '#13ce66'
    },
    inactiveColor: {
      type: String,
      default: '#464852'
    },
    marginBottom: {
      type: String,
      default: '8px'
    },
    value: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      val: this.value,
    }
  },
  computed: {
    style () {
      return {
        marginBottom: this.marginBottom
      }
    }
  },
  watch: {
    value() {
      this.val = this.value
    }
  },
  created() {
    this.val = this.value;
  },
  methods: {
    onChange(val) {
      insertStep(this, [this.targetKey], this.value)
      this.$emit('input', val)
      this.$emit('change', val)
    }
  }
}
</script>

<style lang="less" scoped>
.menu-switch {
  min-height: 36px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 0 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid rgba(255, 255, 255, 0.1);
  
  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-1px);
    
    .label__circle {
      box-shadow: 0 0 8px rgba(var(--primary-color-rgb), 0.6);
    }
  }

  .label {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 500;
    
    &__circle {
      width: 6px;
      height: 6px;
      border-radius: 100%;
      background-color: var(--primary-color);
      transition: all 0.3s ease;
      box-shadow: 0 0 4px rgba(var(--primary-color-rgb), 0.3);
    }
  }
}
</style>
